module.exports = __webpack_public_path__ + "img/LATIN10_17.918f3fe7.jpg";